import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import {
  handleSave,
  serverValidation,
  validateForm,
} from "../../../common/validation/validation";
import AuthorityClient from "../../api-services/authority/authority-client";
import {
  AuthorityKindModel,
  authorityKindSchema,
} from "../../models/Authority";

const CreateAuthorityKind = ({ row, isEdit, handleCallback }) => {
  const { t } = useTranslation();

  const [authorityKind, setAuthorityKind] = useState(new AuthorityKindModel());
  const [errors, setErrors] = useState({});

  var client = new AuthorityClient();

  useEffect(() => {
    setAuthorityKind(row);
    setErrors({});
  }, [row]);

  const createAuthorityKind = async (e) => {
    e.preventDefault();
    const result = validateForm(authorityKind, authorityKindSchema, t);
    setErrors(result);
    if(!result) {
      if (isEdit) var response = await client.updateAuthorityKind(authorityKind);
      else var response = await client.createAuthorityKind(authorityKind);
      validateAction(response);
    }
  };

  const handlePropertyChange = (event) => {
    const obj = { name: event.name, value: event.value };
    const result = handleSave(
      obj,
      authorityKind,
      errors,
      authorityKindSchema,
      t
    );
    setAuthorityKind(result.data);
    setErrors(result.errors);
  };

  const validateAction = (response) => {
    let handledResponse = HandlingResponse(response);
    if (handledResponse.code == 408) {
      var result = serverValidation(handledResponse.data, t);
      setErrors(result);
    } else handleCallback(handledResponse);
  };
  return (
    <form onSubmit={createAuthorityKind}>
      <div>
        <div className="col-md">
          <label>{t("Name")}</label>
          <input
            className="form-control"
            type="text"
            name="name"
            value={authorityKind.name}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.name && <div className="text-danger">{errors.name}</div>}
          <label>{t("Group")}</label>
          <input
            disabled
            className="form-control"
            type="text"
            name="authorityGroupName"
            value={authorityKind.authorityGroupName}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.authorityGroupName && (
            <div className="text-danger">{errors.authorityGroupName}</div>
          )}
          <label>{t("Weight")}</label>
          <input
            className="form-control"
            type="number"
            name="weight"
            value={authorityKind.weight}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.weight && <div className="text-danger">{errors.weight}</div>}
          <input
                id="activeKindCB"
                    type="checkbox"
                    value={authorityKind.active}
                    checked={authorityKind.active}
                    onChange={(event) => {
                        setAuthorityKind({ ...authorityKind, active: event.target.checked });
                    }}
          />
          <label htmlFor="activeKindCB">{t("Active")}</label>
        </div>
        <div className="text-right">
          <button
            className="btn btn-primary m-2"
            onClick={createAuthorityKind}
          >
            {t("Save")}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateAuthorityKind;
